import { useState, useEffect } from "react";
import { Button, Tooltip } from "reactstrap";
import "../../../rightcolumn/layout/carouselV.css";
import "../../../rightcolumn/preview/preview.css";
import React from "react";
import _ from "lodash";
import "/node_modules/react-grid-layout/css/styles.css";
import "/node_modules/react-resizable/css/styles.css";
import httpService from "../../../../services/http.service";
import { useHistory, useLocation } from "react-router-dom";
import Loader from "../../../common/loader";
import "react-toastify/dist/ReactToastify.css";
import ChannelDashboard from "./channelDashboard";
import useUserSubscription from "../../../common/userSubcriptionHook";

let ChannelsListDashboard = (props) => {
  const location = useLocation();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [layoutidTrue, setlayoutidTrue] = useState("");
  const [noHide, setNoHide] = useState(false)
  const [propertyName, setPropertyName] = useState("")
  let [channelsCount, setChannelsCount] = useState(0)
  const [formName, setFormName] = useState("")
  // const [PropertyDataObject, setPropertyDataObject] = useState();
  const [Property, setProperty] = useState();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);
  const { user, checkActiveStatus } = useUserSubscription();
  // const allLayout = async () => {
  //   let dataUserPost = { userID: localStorage.getItem("UserId") };
  //   let LayoutArraydata = await httpService
  //     .CreateUpdate("getSelectedLayout", dataUserPost)
  //     .catch((err) => {
  //       return;
  //     });
  //   const arr1 = [];
  //   for (let i = 0; i < LayoutArraydata.data.data.length; i++) {
  //     let obj = {
  //       value: `${LayoutArraydata.data.data[i].name} (${window.location.origin}/cloud-portal/#/view/${LayoutArraydata.data.data[i]._id})`,
  //       label: `${LayoutArraydata.data.data[i].name} (${window.location.origin}/cloud-portal/#/view/${LayoutArraydata.data.data[i]._id})`,
  //     };
  //     if (LayoutArraydata.data.data[i].checked) {
  //       {
  //         arr1.push(obj);
  //       }
  //     }
  //   }
  //   setArray1(arr1);
  // };

  // useEffect(()=>{
  //   allLayout()
  // },[])

  useEffect(() => {
    if (!props.verifyTokenUser && history.location.pathname != '/login') history.push('/login')
  }, [props.verifyTokenUser])

  useEffect(() => {
    setLoading(true);
    const key1 = location.state?.key1;
    setPropertyName(key1)
    let string = window.location.href.split("/propertychannle/").length > 1
      ? window.location.href.split("/propertychannle/")[1].split("/")[0]
      : ""
    setlayoutidTrue(string);
    setLoading(false);
  }, [])

  const handleClose1 = (e) => {
    console.log(e)
  }

  const CloseChannelForm = () => {
    setNoHide(false)
  }
  const openChannelForm = () => {
    setNoHide(true)
    setFormName("Add")
  }

  useEffect(async () => {
    let string = window.location.href.split("/propertychannle/").length > 1
      ? window.location.href.split("/propertychannle/")[1].split("/")[0]
      : ""

    let dataUserPost = { userID: localStorage.getItem("UserId") };
    let LayoutArraydata = await httpService
      .CreateUpdate("getallpropertybyuser", dataUserPost)
      .catch((err) => {
        return;
      });

    // const arr2 = [];
    // console.log(LayoutArraydata.data.propertyData,"getallpropertybyuserq")

    // for (let i = 0; i < LayoutArraydata.data.propertyData.length; i++) {
    //   console.log(LayoutArraydata.data.propertyData,"getallpropertybyuserq")
    //   let obj = {
    //     PropertyId: `${LayoutArraydata.data.propertyData[i]._id}`,
    //     value: `${LayoutArraydata.data.propertyData[i].Name}`,
    //     label: `${LayoutArraydata.data.propertyData[i].Name}`,
    //     count:`${LayoutArraydata.data.propertyData[i].count}`,
    //   };
    //   if (LayoutArraydata.data.propertyData[i]) {
    //       arr2.push(obj);
    //   }
    // }
    // setArray2(arr2);
    const foundObject = LayoutArraydata?.data?.propertyData.find(obj => obj._id === string);
    setProperty(foundObject)
    // setPropertyDataObject(LayoutArraydata.data.propertyData)
  }, [])

  useEffect(() => {
    if (user) {
      checkActiveStatus()
    }
  }, [user, checkActiveStatus])

  useEffect(() => {
    const customerID = localStorage.getItem("customerId");
    const type = localStorage.getItem("CloudUserType");
    if (customerID === 'Admin' || type === "admin") {
      history.push("/admindashboard");
    }
  }, [])

  console.log(channelsCount, "channelsCount")

  return (
    <div className="mainlayout">
      <div
        className="othercomponentnavbar"
        style={{}}
      >
        {loading ? <Loader /> : null}
        <div className="form-boxdiv ">
          <div className="row form-boxtopline5">
            <div className="col-9" style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <div
                onClick={() => {
                  history.push("/clouddashboard");
                }}
              >
                <Button className="back-btn"><i class="fa fa-chevron-left" aria-hidden="true"></i></Button>
              </div>
              <b>{propertyName} {" / "}  CHANNELS {"  "} </b>


            </div>
            <div className="col-1" id="DisabledAutoHideExample">
              <Button
                disabled={!(channelsCount < 6)}
                className="btn btn-primary btn-sm"
                style={{ float: "right" }}
                onClick={openChannelForm}
              >
                Add Channel
              </Button>
            </div>
            <Tooltip
              placement="top"
              isOpen={tooltipOpen}
              autohide={false}
              target="DisabledAutoHideExample"
              toggle={toggle}
            >
              You can only add up to 6 channels in a Property!
            </Tooltip>
          </div>
          <div>
            <ChannelDashboard props={layoutidTrue} name={handleClose1} show1={noHide} handleClose1={CloseChannelForm} openChannelForm={openChannelForm} setFormName={setFormName} formName={formName} PropertyDataObject={Property} setChannelsCount={setChannelsCount} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChannelsListDashboard;
